import { combineReducers } from 'redux';

import accountModal from 'store/slice/accountModalSlice';
import auth from 'store/slice/authSlice';
import cmsBanner from 'store/slice/cmsBannerSlice';
import featureFlags from 'store/slice/featureFlagsSlice';
import homepage from 'store/reducers/homepageReducer';
import pageLayout from 'store/slice/pageLayoutSlice';
import pdp from 'store/slice/pdpSlice';
import pubnub from 'store/reducers/pubnubReducer';
import search from 'store/reducers/searchReducer';
import userSegments from 'store/reducers/userSegmentsReducer';
import { apiSlice } from 'store/api/apiSlice';

export default combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  accountModal,
  auth,
  cmsBanner,
  featureFlags,
  homepage,
  pageLayout,
  pdp,
  pubnub,
  search,
  userSegments,
});
